import { EntryStatus } from '@/components/entry-card';

import { Result } from '../hooks/types';

/**
 * Maps a settled bet result to its entry-card status badge — or `null` for results the shared
 * settled card does not own (`PENDING` and unknown). Push, cancel and manual-cancel all surface as
 * a refund — the API keeps `MANUALLY_CANCELLED` distinct on the wire (esportspools SBK-2480), so it
 * reaches the Finished/Refunded lists and must be mapped here.
 */
export const getSettledEntryStatus = (result: Result): EntryStatus | null => {
    switch (result) {
        case 'WON':
            return EntryStatus.Won;
        case 'LOST':
            return EntryStatus.Lost;
        case 'PUSHED':
        case 'CANCELLED':
        case 'MANUALLY_CANCELLED':
            return EntryStatus.Refunded;
        case 'CASHEDOUT':
            return EntryStatus.CashedOut;
        default:
            return null;
    }
};
